/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
  Form,
  Button,
  Row,
  Col,
  Spin,
  Input,
  message,
} from 'antd';
import { formatReceived } from 'utils/formatValues';
import { onError, onSuccess } from 'utils/handlers';
import { ESTATUS_AUTORIZADO } from 'utils/constants';
import Table from 'components/Table';
import Select from 'components/Select';
import API from 'utils/api';
import { getAreas } from 'api/catalogos/index';
import { checkToken } from 'api/utils';
import { getJornadasModificacionDetalle, patchJornadaModificacionDetalle, postJornadaModificacionDetalle } from 'api/catalogos/JornadaModificacionDetalle';
import { getTiposDeEmpleados } from 'api/catalogos/tiposDeEmpleados';
import { getDatoOperacionalesDeEmpleados, getDatoOperacionalPorEmpleadoOptimized } from 'api/estructuraOrganizacional/datosOperacionalesDeEmpleados';
import { getTiposDeNominasEmpleados } from 'api/nominas/catalogos/tiposNominasEmpleados';
import { getPuestos } from 'api/catalogos/puestos';
import { getAdministracionDePlazasvistaOptimized } from 'api/catalogos/admnistracionDePlazas';
import { getPlazasvistaOptimized } from 'api/catalogos/plazas';
import { getEmpleadosvistaOptimized } from 'api/estructuraOrganizacional/empleados';
import { SearchOutlined } from '@ant-design/icons';

export const jornadadetalleHorarioPermission = {
  permissionModel: 'jornadadetallehorario',
  hasAllViewPermissions: true,
};

const TablaDetalleEmpleados = ({ onSeleccionChange, JornadaModificacion }) => {
  const [form] = Form.useForm();
  const [formDatos] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setVisible] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [data, setData] = useState([]);
  const [datosOperacionales, setDatosOperacionales] = useState([]);
  const [tiposEmpleados, setTiposEmpleados] = useState([]);
  const [detalleData, setDetalleData] = useState([]);
  const [loadingDetalle, setLoadingDetalle] = useState(false);
  const [empleados, setEmpleados] = useState([]);
  const [tiposNominasEmpleados, setTiposNominasEmpleados] = useState([]);
  const [puestos, setPuestos] = useState([]);
  const [areas, setAreas] = useState([]);
  const [plazas, setPlazas] = useState([]);
  const [asignacionPlazas, setAsignacionPlazas] = useState([]);
  const [empleadosSeleccionados, setEmpleadosSeleccionados] = useState([]);

  const formInstances = [
    form,
    formDatos,
  ];

  const fetchEmpleadosFiltrados = async (filters) => {
    try {
      setLoadingDetalle(true);

      const filtrosLimpios = Object.fromEntries(
        Object.entries(filters).filter(([, v]) => v !== null && v !== undefined && v !== ''),
      );

      const filtrados = empleados.filter((emp) => {
        if (
          filtrosLimpios.numero_de_empleado
        && !String(emp.numero_de_empleado || '').includes(filtrosLimpios.numero_de_empleado)
        ) return false;

        if (
          filtrosLimpios.numero_y_nombre_completo
        && !String(emp.numero_y_nombre_completo || '')
          .toLowerCase()
          .includes(filtrosLimpios.numero_y_nombre_completo.toLowerCase())
        ) return false;

        if (
          filtrosLimpios.plaza
        && String(emp.plaza) !== String(filtrosLimpios.plaza)
        ) return false;

        if (
          filtrosLimpios.directorio_area
        && String(emp.directorio_area) !== String(filtrosLimpios.directorio_area)
        ) return false;

        if (
          filtrosLimpios.puesto
        && String(emp.puesto) !== String(filtrosLimpios.puesto)
        ) return false;

        if (
          filtrosLimpios.tipo_empleado
        && String(emp.tipo_empleado) !== String(filtrosLimpios.tipo_empleado)
        ) return false;

        if (
          filtrosLimpios.tipos_de_nomina_empleado
  && String(emp.tipos_de_nomina_empleado) !== String(filtrosLimpios.tipos_de_nomina_empleado)
        ) return false;

        return true;
      });

      setDetalleData(filtrados);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('[Jornada Modificaciones] error al cargar el detalle de empleados', err);
    } finally {
      setLoadingDetalle(false);
    }
  };

  useEffect(() => {
    if (!empleados.length || !datosOperacionales.length || !asignacionPlazas.length) return;

    const empleadosConDatos = empleados.map((emp) => {
      const datos = datosOperacionales.find((d) => d.empleado === emp.id);
      const asignacion = asignacionPlazas.find((a) => a.empleado_id === emp.id);

      return {
        ...emp,
        plaza: asignacion?.plaza_id,
        puesto: asignacion?.puesto_id,
        directorio_area: asignacion?.directorio_area_id,
        tipo_empleado: asignacion?.tipo_de_empleado_id,
        // eslint-disable-next-line max-len
        tipo_nomina_empleado: asignacion?.tipo_nomina_empleado_id || datos?.tipo_de_nomina_empleado || null,

      };
    });

    setEmpleados(empleadosConDatos);
    setDetalleData(empleadosConDatos);
  }, [empleados, datosOperacionales, asignacionPlazas]);

  const fetchData = async () => {
    setLoading(true);
    const _data = await getJornadasModificacionDetalle();
    setData(formatReceived(_data));
    setLoading(false);
  };

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        _tiposEmpleados,
        _datosOperacionales,
        _tipos_nominas_empleados,
        _puestos,
        _areas,
        _asignacion_plazas,
        _plazas,
        _empleadosData,
      ] = await Promise.all([
        getTiposDeEmpleados(),
        getDatoOperacionalPorEmpleadoOptimized(),
        getTiposDeNominasEmpleados(),
        getPuestos(),
        getAreas({ estados_globales: ESTATUS_AUTORIZADO }),
        getAdministracionDePlazasvistaOptimized(),
        getPlazasvistaOptimized(),
        getEmpleadosvistaOptimized(),
      ]);
        //  Aquí enriqueces a los empleados
      const empleadosEnriquecidos = _empleadosData.map((emp) => {
        const datos = _datosOperacionales.find((d) => d.empleado === emp.id);
        const asignacion = _asignacion_plazas.find((a) => a.empleado_id === emp.id);

        return {
          ...emp,
          plaza: asignacion?.plaza_id || datos?.plaza || null,
          puesto: asignacion?.puesto_id || datos?.puesto_id || null,
          directorio_area: asignacion?.directorio_area_id || datos?.directorio_area_id || null,
          tipo_empleado: asignacion?.tipo_de_empleado_id || datos?.tipo_de_empleado_id || null,
          // eslint-disable-next-line max-len
          tipos_de_nomina_empleado: asignacion?.tipo_nomina_empleado_id || datos?.tipo_de_nomina_empleado || null,

        };
      });
      if (mounted) {
        setTiposEmpleados(_tiposEmpleados);
        setTiposNominasEmpleados(_tipos_nominas_empleados);
        setPuestos(_puestos);
        setAreas(_areas);
        setAsignacionPlazas(_asignacion_plazas);
        setPlazas(_plazas);
        setEmpleados(empleadosEnriquecidos); //  ya enriquecido
        setDetalleData(empleadosEnriquecidos); //  inicial en tabla detalle
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
    // eslint-disable-next-line
}, []);

  const onClickGuardar = async () => {
    try {
      if (!JornadaModificacion) {
        message.warning('No hay jornada seleccionada.');
        return;
      }

      if (!empleadosSeleccionados?.length) {
        message.warning('Selecciona al menos un empleado.');
        return;
      }

      setLoading(true);

      // Construir payload como [{ empleado: id }, ...]
      const payload = empleadosSeleccionados.map((emp) => ({
        empleado: emp.id,
      }));

      const url = `/catalogos/modificacion-de-jornada-agregar-modificaciones/${JornadaModificacion}/`;
      const response = await API.put(url, payload);

      if (response) {
        message.success('Empleados guardados exitosamente.');
        await fetchData(); // Recargar tabla si es necesario
      }
    } catch (error) {
      onError(error, setLoading);
    } finally {
      setLoading(false);
    }
  };

  const handleOnRowClick = (record) => {
    const enrichedRecord = {
      ...record,
      tipo_empleado: tiposEmpleados.find((t) => t.id === record.tipo_empleado),
      tipos_de_nomina_empleado: tiposNominasEmpleados.find((t) => t.id === record.tipos_de_nomina_empleado),
      puesto: puestos.find((p) => p.id === record.puesto),
      directorio_area: areas.find((a) => a.id === record.directorio_area),
    };

    setSelectedRowKeys((prevSelected) => {
      const alreadySelected = prevSelected.includes(record.id);
      let nuevosIds;
      let nuevosEmpleados;

      if (alreadySelected) {
        nuevosIds = prevSelected.filter((id) => id !== record.id);
        nuevosEmpleados = empleadosSeleccionados.filter((emp) => emp.id !== record.id);
      } else {
        nuevosIds = [...prevSelected, record.id];
        nuevosEmpleados = [...empleadosSeleccionados, enrichedRecord];
      }

      setEmpleadosSeleccionados(nuevosEmpleados);
      if (onSeleccionChange) onSeleccionChange(nuevosEmpleados);
      return nuevosIds;
    });
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: (keys, selectedRows) => {
      const enrichedRows = selectedRows.map((record) => ({
        ...record,
        tipo_empleado: tiposEmpleados.find((t) => t.id === record.tipo_empleado),
        tipos_de_nomina_empleado: tiposNominasEmpleados.find((t) => t.id === record.tipos_de_nomina_empleado),
        puesto: puestos.find((p) => p.id === record.puesto),
        directorio_area: areas.find((a) => a.id === record.directorio_area),
      }));

      setSelectedRowKeys(keys);
      setEmpleadosSeleccionados(enrichedRows);
      if (onSeleccionChange) onSeleccionChange(enrichedRows);
    },
    type: 'checkbox',
  };

  const columnsDetalle = [
    {
      titleText: 'Empleado',
      dataIndex: 'numero_y_nombre_completo',
      key: 'numero_y_nombre_completo',
      width: 250,
    },
    {
      titleText: 'Número de Empleado',
      dataIndex: 'numero_de_empleado',
      key: 'numero_de_empleado',
      width: 180,
    },
    {
      titleText: 'Tipo de Nómina',
      dataIndex: 'tipos_de_nomina_empleado',
      key: 'tipos_de_nomina_empleado',
      width: 200,
      render: (val) => tiposNominasEmpleados.find((t) => t.id === val)?.descripcion || val,
    },
    {
      titleText: 'Tipo de Empleado',
      dataIndex: 'tipo_empleado',
      key: 'tipo_empleado',
      width: 200,
      render: (val) => tiposEmpleados.find((t) => t.id === val)?.descripcion || val,
    },
    {
      titleText: 'Puesto',
      dataIndex: 'puesto',
      key: 'puesto',
      width: 200,
      render: (val) => puestos.find((p) => p.id === val)?.clave_y_descripcion || val,
    },
    {
      titleText: 'Área',
      dataIndex: 'directorio_area',
      key: 'directorio_area',
      width: 250,
      render: (val) => areas.find((a) => a.id === val)?.clave_y_nombre || val,
    },
  ];
  const getControls = () => {
    const botonesComunes = {
      onClickGuardar,
    };

    return botonesComunes;
  };
  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        <Form
          layout="vertical"
          onFinish={fetchEmpleadosFiltrados}
        >
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item name="numero_de_empleado" label="Número de Empleado">
                <Input placeholder="Ej. 123" allowClear />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item
                name="numero_y_nombre_completo"
                label="Nombre Completo"
              >
                <Input placeholder="Ej. Maximino Villegas Gutierrez" allowClear />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item
                name="plaza"
                label="Plaza"
              >
                <Select
                  dataSource={plazas}
                  keyProp="id"
                  labelProp="clave_y_descripcion"
                  allowClear
                  placeholder="Selecciona una plaza"
                />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item name="directorio_area" label="Área">
                <Select
                  dataSource={areas}
                  keyProp="id"
                  labelProp="clave_y_nombre"
                  allowClear
                  placeholder="Selecciona un área"
                />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item name="puesto" label="Puesto">
                <Select
                  dataSource={puestos}
                  keyProp="id"
                  labelProp="clave_y_descripcion"
                  allowClear
                  placeholder="Selecciona un puesto"
                />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item name="tipos_de_nomina_empleado" label="Tipo de Nómina">
                <Select
                  dataSource={tiposNominasEmpleados}
                  keyProp="id"
                  labelProp="descripcion"
                  allowClear
                  placeholder="Selecciona un tipo de nómina"
                />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item name="tipo_empleado" label="Tipo de Empleado">
                <Select
                  dataSource={tiposEmpleados}
                  keyProp="id"
                  labelProp="descripcion"
                  allowClear
                  placeholder="Selecciona un tipo de empleado"
                />
              </Form.Item>
            </Col>
          </Row>

          <Button
            type="primary"
            htmlType="submit"
            icon={<SearchOutlined />}
            style={{ marginBottom: 16 }}
          >
            Buscar
          </Button>
        </Form>
        <Table
          cols={columnsDetalle}
          controls={getControls()}
          data={detalleData}
          loading={loadingDetalle}
          pagination
          rowSelection={rowSelection}
          handleOnRowClick={handleOnRowClick}

        />
      </Spin>
    </Row>
  );
};

export default TablaDetalleEmpleados;
